<template>
  <div class="sent-popup" v-if="mailSent">
    <div class="sent-popup__block">
      <p class="sent-popup__text">You will receive the requested file(s) via email.</p>
      <a @click="close" class="simple-button">Close</a>
    </div>
  </div>
</template>

<script>
export const close = ({ dispatch }) => {
  dispatch("MAIL_CONFIRMED");
};

export default {
  vuex: {
    getters: {
      mailSent: state => state.mailSent
    },
    actions: { close }
  }
};
</script>

<style lang="scss">
  @import '../assets/scss/variables.scss';
  @import '../assets/scss/mixins.scss';

  .sent-popup{
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0,0,0,.8);
    &__block{
      background: $brown-light;
      padding: 50px;
      width: 550px;
      position: absolute;
      top: 50%;
      left: 50%;
      transform: translate(-50%,-50%);
      z-index: 1;
      box-sizing: border-box;
    }

    &__text{
      margin: 0 0 35px;
      color: #fff;
    }
  }
</style>



// WEBPACK FOOTER //
// SentPopup.vue?38d5a473